import React, { useContext, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../App";
import ProjectPlanningImgDE from "../../assets/img/scenario/project-planning-de.png";
import ProjectPlanningImg from "../../assets/img/scenario/project-planning-en.png";
import FormSubmissionFailedDialog from "../../Dialogs/FormSubmissionFailedDialog/FormSubmissionFailedDialog";
import FormSubmissionSuccessDialog from "../../Dialogs/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog";
import SAPHeroBanner from "../../ReusableComponents/SAPHeroBanner/SAPHeroBanner";
import AuthService from "../Login/AuthService";
import { getApiUrl, USER_API_BASE_MAIL_URL } from "../../Constants/Api";

export const OntegoChecklistsHero = () => {
  const { t, i18n } = useTranslation();
  const [
    isFormSubmissionSuccessDialogOpen,
    setIsFormSubmissionSuccessDialogOpen,
  ] = useState(false);
  const [
    isFormSubmissionFailedDialogOpen,
    setIsFormSubmissionFailedDialogOpen,
  ] = useState(false);
  const currentLanguage = i18n.language;
  const { client } = useContext(AppContext);

  const submitRequest = async () => {
    try {
      const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
      const formENId = process.env.REACT_APP_SUBMISSION_FORM_ID_EN;
      const formDEId = process.env.REACT_APP_SUBMISSION_FORM_ID_DE;
      const formId = currentLanguage === "en" ? formENId : formDEId;
      const baseUrl =
        "https://api.hsforms.com/submissions/v3/integration/submit";
      const nameParts = client.name.trim().split(/\s+/);
      const email = client.email;
      const firstname = nameParts[0] || "";
      const lastname = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
      const response = await axios.post(`${baseUrl}/${portalId}/${formId}`, {
        fields: [
          {
            objectTypeId: "0-1",
            name: "email",
            value: email,
          },
          {
            objectTypeId: "0-1",
            name: "firstname",
            value: firstname,
          },
          {
            objectTypeId: "0-1",
            name: "lastname",
            value: lastname,
          },
        ],
      });
      return response;
    } catch (error) {
      console.error("There was an error", error);
      throw error;
    }
  };

  const sendEmail = async () => {
    try {
      await axios.post(
        `${getApiUrl()}${USER_API_BASE_MAIL_URL}/download-checklist`,
        { email: client.email, name: client.name, locale: currentLanguage },
        AuthService.getAuthHeader()
      );
    } catch (error) {
      console.error("Failed to send download checklist email", error);
    }
  };

  const handleDownloadPDF = () => {
    AuthService.getUserInfo();
    submitRequest()
      .then(async (response) => {
        if (response.request.status !== 200) return;
        await sendEmail();
        setIsFormSubmissionSuccessDialogOpen(true);
      })
      .catch(() => {
        setIsFormSubmissionFailedDialogOpen(true);
      });
  };

  const handleCloseRegisterDialog = () => {
    setIsFormSubmissionSuccessDialogOpen(false);
    setIsFormSubmissionFailedDialogOpen(false);
  };

  const checklistImage =
    currentLanguage === "en" ? ProjectPlanningImg : ProjectPlanningImgDE;

  return (
    <>
      <SAPHeroBanner
        subtitle={`${t("scenario.greetingWords")} ${client.name}`}
        title={t("scenario.ontegoChecklists")}
        description={t("scenario.ontegoChecklistsDesc")}
        buttonText={t("scenario.ontegoChecklistsDownload")}
        onButtonClick={handleDownloadPDF}
        assetImage={checklistImage}
        assetImageAlt="Evaluation Checklist"
      />
      <FormSubmissionSuccessDialog
        open={isFormSubmissionSuccessDialogOpen}
        onClose={handleCloseRegisterDialog}
      />
      <FormSubmissionFailedDialog
        open={isFormSubmissionFailedDialogOpen}
        onClose={handleCloseRegisterDialog}
      />
    </>
  );
};

export default React.memo(OntegoChecklistsHero);
